import { render, staticRenderFns } from "./SubscriptionContent.vue?vue&type=template&id=e534bd44&scoped=true"
import script from "./SubscriptionContent.vue?vue&type=script&lang=js"
export * from "./SubscriptionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e534bd44",
  null
  
)

export default component.exports